module.exports = __webpack_public_path__ + "static/media/Logo.98d05398.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Logo.svg
 ** module id = 190
 ** module chunks = 0
 **/